import { Link } from 'react-router-dom'
import { Button } from '@/components/ui/button'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'
import { formatSwedishDateTime } from '@/lib/format'
import { describeAppliedLog } from '@/lib/history'
import type { HistoryEntry } from '@/api/types'

interface HistoryAppliedCardProps {
  entry: HistoryEntry
  isEarlierRound: boolean
  isReverting: boolean
  onRevert: (entryId: number) => void
}

export function HistoryAppliedCard({ entry, isEarlierRound, isReverting, onRevert }: HistoryAppliedCardProps): React.ReactElement {
  const summary = describeAppliedLog(entry.log)
  const title = isEarlierRound ? 'Inlagd i en tidigare omgång' : 'Inlagd'

  const handleRevert = (): void => {
    onRevert(entry.id)
  }

  return (
    <Card className="shadow-none border-emerald-300">
      <CardHeader>
        <CardTitle>{title}</CardTitle>
        <CardDescription>
          {formatSwedishDateTime(entry.applied_at)} av {entry.applied_by_name ?? 'okänd'}
        </CardDescription>
      </CardHeader>
      <CardContent className="space-y-3 text-sm">
        <p>{summary}</p>
        <div className="flex flex-wrap gap-2">
          <Button
            asChild
            variant="outline"
            className="rounded-none"
          >
            <Link to={`/customers/${entry.customer_id}`}>Öppna kundkortet</Link>
          </Button>
          {!isEarlierRound && (
            <Button
              variant="ghost"
              className="rounded-none text-destructive hover:text-destructive"
              disabled={isReverting}
              onClick={handleRevert}
            >
              Ångra inläggningen
            </Button>
          )}
        </div>
      </CardContent>
    </Card>
  )
}
